/**
 *
 * Wait for an HTML element to be loaded like `div`, `span`, `img`, etc.
 * ex: `onElementLoaded("div.some_class").then(()=>{}).catch(()=>{})`
 * @param {*} elementToObserve wait for this element to load
 * @param {*} oneTime (optional) disconnect observer after first time run if true default is false
 * @param {*} parentStaticElement (optional) if parent element is not passed then `document` is used
 * @return {*} Promise - return promise when `elementToObserve` is loaded
 */
onElementLoaded = function (elementToObserve, oneTime, parentStaticElement, callback) {
    const promise = new Promise((resolve, reject) => {
        try {
            if (document.querySelector(elementToObserve)) {
                resolve(true);
                return;
            }
            const parentElement = parentStaticElement
                ? document.querySelector(parentStaticElement)
                : document;

            oneTime = oneTime ? oneTime : false;

            const observer = new MutationObserver((mutationList, obsrvr) => {
                const divToCheck = document.querySelector(elementToObserve);

                if (divToCheck) {
                    if (oneTime) {
                        obsrvr.disconnect(); // stop observing => CHECK AGAIN DO WE NEED LISTEN MORE
                    }
                    if (typeof callback === "function") {
                        callback(divToCheck)
                    }
                    resolve(true);
                }
            });

            // start observing for dynamic div
            observer.observe(parentElement, {
                childList: true,
                subtree: true,
            });
        } catch (e) {
            reject(Error("some issue... promise rejected"));
        }
    });
    return promise;
};

/**
 *
 * Wait for an HTML element to be modified like `div`, `span`, `img`, etc.
 * ex: `onElementModified("div.some_class").then(()=>{}).catch(()=>{})`
 * @param {*} elementToWatch wait for this element to load
 * @param {*} callback (optional) if callback is callable then make call
 * @return {*} Promise - return promise when `onElementModified` is loaded
 */
onElementModified = function (elementSelectorToWatch, callback) {
    const promise = new Promise((resolve, reject) => {
        try {
            if (!document.querySelector(elementSelectorToWatch)) {
                //resolve(true);
                reject(Error(`no element present: ${elementSelectorToWatch}`));
                return;
            }
            const eleToCheck = document.querySelector(elementSelectorToWatch);
            eleToCheck.addEventListener("DOMSubtreeModified", function (e) {
                if (typeof callback === "function") {
                    callback()
                }
                resolve(true);
            })
        } catch (e) {
            reject(Error("some issue... promise rejected"));
        }
    });
    return promise;
};

/**
 *
 * Wait for an HTML element to be modified like `div`, `span`, `img`, etc.
 * ex: `onElementModified("div.some_class").then(()=>{}).catch(()=>{})`
 * @param {*} elementToWatch wait for this element to load
 * @param {*} callback (optional) if callback is callable then make call
 * @return {*} Promise - return promise when `onElementModified` is loaded
 */
onElementClick = function (elementSelectorToWatch, callback) {
    const promise = new Promise((resolve, reject) => {
        try {
            if (!document.querySelector(elementSelectorToWatch)) {
                resolve(true);
                return;
            }
            const eleToCheckArr = document.querySelectorAll(elementSelectorToWatch);
            eleToCheckArr.forEach((e) => {
                e.addEventListener("click", function (e) {
                    if (typeof callback === "function") {
                        callback(e)
                    }
                    resolve(true);
                })
            })
        } catch (e) {
            reject(Error("some issue... promise rejected"));
        }
    });
    return promise;
};

const zenbPointSelectors = {
    rootId: 'loyaltylion',
    header: 'div.lion-header',
    headerYourPoint: 'div.lion-header__your-points',
    headerYourPointValue: 'div.lion-header__your-points > span > strong',
    headerPendingPoint: 'div.lion-header__pending-points',
    headerNav: 'nav.lion-header__nav',
    ruleListTrigger: 'div.rules__link.js-trigger',
    rewardTabTrigger: 'div.js-tab-trigger',
    rewardList: 'div.lion-rewards-list',
    rewardItem: 'div.lion-reward-item',
    rewardItemActions: 'div.lion-reward-item__actions',
    rewardClaimedItem: 'div.lion-claimed-reward-item',
    historyList: 'table.lion-history-table',
    modal: 'div.lion-modal',
    modalLoaded: 'div.lion-modal.lion-modal--zenb',
    modalRedeemConfirmBox: 'div.lion-redeem-reward-modal__confirm-box',
    modalAfterRedeemSummary: 'div.lion-redeem-reward-modal__summary'
};

function ZenbPointComponent() {

    const setupEvent = function () {
        onElementLoaded(zenbPointSelectors.rewardList, true).then(() => {
            watchTriggers();
        }).catch(() => { });

        onElementLoaded(zenbPointSelectors.rewardItemActions, true).then(() => {
            makeChangeHtmlRewardList()
            makeClickRewardList()
        })

        onElementLoaded(zenbPointSelectors.rewardClaimedItem, true).then(() => {
            makeChangeHtmlRewardClaimedList()
            removeNonExistCoupon()
        })

        onElementLoaded(zenbPointSelectors.modal, false, null, function (modal) {
            if (!modal.classList.contains('lion-modal--zenb')) {
                modal.classList.add('lion-modal--zenb')

                const rewardButtons = document.querySelectorAll('.lion-action-button.lion-redeem-reward-modal__button.lion-redeem-reward-modal__button--confirm');
                let originalButton = null;
                if (rewardButtons.length > 1) {
                    originalButton = rewardButtons[1];
                    originalButton.style.display = 'none';
                }

                if (modal.classList.contains('lion-redeem-reward-modal')) {
                    makeChangeHtmlRewardModalConfirmBox(originalButton)
                }
                if (modal.classList.contains('lion-modal--history-info')) {
                    makeChangeHtmlRewardModalComment()
                }
                watchClicksOrder()
            } else {
                const summary = modal.querySelector(zenbPointSelectors.modalAfterRedeemSummary)
                if (summary && !summary.classList.contains('lion-redeem-reward-modal__summary-zenb')) {
                    summary.classList.add('lion-redeem-reward-modal__summary-zenb')
                    makeChangeHtmlAfterRedeemModalSummary()
                    watchClicksOrder()
                }
            }
        }).then(() => {
        })

        onElementLoaded(zenbPointSelectors.historyList, true).then(() => {
            makeChangeHtmlHistoryList()
        })

    }

    const watchChanges = function () {
        onElementModified(zenbPointSelectors.headerYourPointValue).then(() => {
        }).catch(() => { });
    }

    const watchTriggers = function () {
        // for ruleListTrigger

        onElementClick(zenbPointSelectors.ruleListTrigger, function (ele) {
            // handle trigger
            const eleTrigger = document.querySelector(zenbPointSelectors.ruleListTrigger)
            const idTarget = eleTrigger.getAttribute('target')
            const eleTarget = document.getElementById(idTarget)
            eleTrigger.classList.toggle('is-open')
            eleTarget.classList.toggle('is-active')
        }).then(() => {
        }).catch(() => { });

        onElementClick(zenbPointSelectors.rewardTabTrigger, function (event) {
            document.querySelectorAll(zenbPointSelectors.rewardTabTrigger).forEach((e) => {
                const idT = e.getAttribute('target')
                const eleT = document.getElementById(idT)
                e.classList.remove('is-active')
                eleT.classList.remove('is-active')
            })

            // handle trigger
            const eleTrigger = event.target
            const idTarget = eleTrigger.getAttribute('target')
            const eleTarget = document.getElementById(idTarget)

            eleTrigger.classList.add('is-active')
            eleTarget.classList.add('is-active')

        }).then(() => {
        }).catch(() => { });
    }

    const watchClicksOrder = function () {

        onElementClick('.product__card--actions-cart', function (event) {
            closeModal()
        })
    }

    const closeModal = function () {
        const modalClose = document.querySelector('.lion-modal__close-button')
        if (modalClose) {
            modalClose.click()
        }
    }

    // const makeChangeHtmlRewardList = function () {
    //     document.querySelectorAll(zenbPointSelectors.rewardItem).forEach((e, idx) => {
    //         let parent = e;
    //         const title = parent.querySelector(".lion-reward-item__title").innerText;
    //         const redeemAmount = extractAmountRedeemFromTitle(title);
    //         const childIcon = parent.querySelector(".lion-reward-item__icon");
    //         childIcon.innerHTML = redeemAmount + "<br/>" + "OFF";

    //         // Change icon color
    //         const buttonAction = parent.querySelector("button.lion-action-button");
    //         if (buttonAction && buttonAction.classList.contains("lion-action-button--disabled")) {
    //             parent.classList.add('is-disabled')
    //         }
    //     })
    // }

    // const makeChangeHtmlRewardList = function () {
    //     document.querySelectorAll(zenbPointSelectors.rewardItem).forEach((e, idx) => {
    //         let parent = e;
    //         const title = parent.querySelector(".lion-reward-item__title").innerText;
    //         const redeemAmount = extractAmountRedeemFromTitle(title);
    //         const yenSymbol = redeemAmount[0];  // 最初の文字 (¥)
    //         const yenNumber = redeemAmount.slice(1);  // 最初の文字以降 (金額)
    //         const childIcon = parent.querySelector(".lion-reward-item__icon");
            
    //         childIcon.innerHTML = `
    //             <div class="yen-wrapper">
    //                 <span class="yen-symbol"></span>
    //                 <span class="yen-number"></span>
    //                 <span class="yen-off">OFF</span>
    //             </div>
    //         `;
    
    //         // Change icon color
    //         const buttonAction = parent.querySelector("button.lion-action-button");
    //         if (buttonAction && buttonAction.classList.contains("lion-action-button--disabled")) {
    //             parent.classList.add('is-disabled');
    //         }
    //     });
    // }

    const makeChangeHtmlRewardList = function () {
        document.querySelectorAll(zenbPointSelectors.rewardItem).forEach((e, idx) => {
            let parent = e;
            const title = parent.querySelector(".lion-reward-item__title").innerText;
            const redeemAmount = extractAmountRedeemFromTitle(title);
            const yenNumber = redeemAmount.replace("¥", "");  // ¥を取り除いて数値部分を取得
            const childIcon = parent.querySelector(".lion-reward-item__icon");
        
            // 金額に応じた画像ファイル名を動的に生成
            let imageUrl;
    
            switch (yenNumber) {
                case "100":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_100.png?v=169102292476836454451754355968";
                    break;
                case "200":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_200.png?v=168151831674440261521754355969";
                    break;
                case "300":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_300.png?v=60678104810395983661754355970";
                    break;
                case "400":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_400.png?v=51508862563593314391754355970";
                    break;
                case "500":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_500.png?v=22833405977087413941754355971";
                    break;
                case "600":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_600.png?v=7124691917207252891754355971";
                    break;
                case "700":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_700.png?v=30542353132422445061754355971";
                    break;
                case "800":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_800.png?v=15447633233214608651754355972";
                    break;
                case "900":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_900.png?v=38133705112757806111754355972";
                    break;
                case "1,000":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_1000.png?v=170752626227111753281754355968";
                    break;
                case "2,000":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_2000.png?v=100099993412999525851754355969";
                    break;
                case "送料無料":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_default_shipping.png?v=72591230134275690821754355974";
                default:
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_default.png?v=27869217525680045011754355973";  
            }
    
            // 画像を表示するためのHTMLを設定
            childIcon.innerHTML = `
                <img src="${imageUrl}" alt="${yenNumber}円割引クーポン" class="coupon-image">
            `;
        
            // アイコンの色を変更する（必要に応じて）
            const buttonAction = parent.querySelector("button.lion-action-button");
            if (buttonAction && buttonAction.classList.contains("lion-action-button--disabled")) {
                parent.classList.add('is-disabled');
            }
        });
    }

    const makeClickRewardList = function () {
        document.querySelectorAll(zenbPointSelectors.rewardItem).forEach((e, idx) => {
            let parent = e;
            parent.addEventListener('click', (e) => {
                const child = parent.querySelector("button.lion-action-button");
                if (child.getAttribute('data-testid') === "redeem-reward-button" && !child.classList.contains("lion-action-button--disabled")) {
                    child.click();
                }
            })
        })
    }

    // const makeChangeHtmlRewardClaimedList = function () {
    //     document.querySelectorAll(zenbPointSelectors.rewardClaimedItem).forEach((e, idx) => {
    //         let parent = e;
    //         const title = parent.querySelector(".lion-claimed-reward-item__title").innerText;
    //         const redeemAmount = extractAmountRedeemFromTitle(title);
    //         const childIcon = parent.querySelector(".lion-claimed-reward-item__icon");
    //         childIcon.innerHTML = redeemAmount + "<br/>" + "OFF";

    //         const timeClaimed = parent.querySelector('.lion-claimed-reward-item__date').innerText
    //         if (timeClaimed && (timeClaimed.includes("year ago") || timeClaimed.includes("years ago"))) {
    //             //parent.classList.add("is-hidden")
    //         }
    //     })
    // }

    const makeChangeHtmlRewardClaimedList = function () {
        document.querySelectorAll(zenbPointSelectors.rewardClaimedItem).forEach((e, idx) => {
            let parent = e;
            const title = parent.querySelector(".lion-claimed-reward-item__title").innerText;
            const redeemAmount = extractAmountRedeemFromTitle(title);
            const yenNumber = redeemAmount.replace("¥", "");  // ¥を取り除いて数値部分を取得
            const childIcon = parent.querySelector(".lion-claimed-reward-item__icon");
        
            // 金額に応じた画像ファイル名を動的に生成
            let imageUrl;
    
            switch (yenNumber) {
                case "100":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_100.png?v=169102292476836454451754355968";
                    break;
                case "200":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_200.png?v=168151831674440261521754355969";
                    break;
                case "300":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_300.png?v=60678104810395983661754355970";
                    break;
                case "400":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_400.png?v=51508862563593314391754355970";
                    break;
                case "500":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_500.png?v=22833405977087413941754355971";
                    break;
                case "600":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_600.png?v=7124691917207252891754355971";
                    break;
                case "700":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_700.png?v=30542353132422445061754355971";
                    break;
                case "800":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_800.png?v=15447633233214608651754355972";
                    break;
                case "900":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_900.png?v=38133705112757806111754355972";
                    break;
                case "1,000":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_1000.png?v=170752626227111753281754355968";
                    break;
                case "2,000":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_2000.png?v=100099993412999525851754355969";
                    break;
                case "送料無料":
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_default_shipping.png?v=72591230134275690821754355974";
                    break;
                default:
                    imageUrl = "//zenb.jp/cdn/shop/t/212/assets/coupon_default.png?v=27869217525680045011754355973";  
            }
    
            // 画像を表示するためのHTMLを設定
            childIcon.innerHTML = `
                <img src="${imageUrl}" alt="${yenNumber}円割引クーポン" class="coupon-image">
            `;
    
            // アイコンの色を変更する（必要に応じて）
            const timeClaimed = parent.querySelector('.lion-claimed-reward-item__date').innerText;
            if (timeClaimed && (timeClaimed.includes("year ago") || timeClaimed.includes("years ago"))) {
                // parent.classList.add("is-hidden");
            }
        });
    }
    
    
    const makeChangeHtmlRewardModalConfirmBox = function (originalButton) {
        const title = document.querySelector(".lion-modal__title").innerText;
        const redeemAmount = extractAmountRedeemFromTitle(title);
        const imgUrl = fromTitleToCouponImage(title, 'reward')
        const amountClass = imgUrl.includes("_back.png") === false ? 'is-hidden' : ''
        const rotateClass = imgUrl.includes("_back.png") === false ? 'rotate-5deg' : ''

        const imageEl = document.querySelector('.lion-redeem-reward-modal__minimum-spend')
        imageEl.innerHTML += `<div class="bg-zenb-point"><img class="bg-zenb-point__img" src="${imgUrl}"/><div class="zenb-point-amount ${amountClass}">${redeemAmount}<span>OFF</span></div></div>`

        document.querySelector('div.lion-modal--zenb .lion-modal__close-button').innerHTML = '< サンクスマイルポイントに戻る'
        document.querySelector('.lion-redeem-reward-modal__confirm-summary').innerHTML = ''
        document.querySelector('.lion-action-button.lion-redeem-reward-modal__button.lion-redeem-reward-modal__button--confirm').innerHTML = '交換する'


        // （〜ポイント消費）
        const pointsConsumedText = document.createElement('div');
        pointsConsumedText.className = 'consumption-text'
        pointsConsumedText.innerText = `（${redeemAmount.replace("¥", "")}ポイント消費）`;
        pointsConsumedText.style.cssText = "font-size: 16px; color: #1a1a1a; padding-top: 4px; text-align: center;";
        const titleElement = document.querySelector(".lion-modal__title");
        titleElement.insertAdjacentElement('afterend', pointsConsumedText);

        const buttonContainer = document.querySelector('.lion-redeem-reward-modal__button-container');
        if (buttonContainer) {
            const pElement = document.createElement('p');
            pElement.innerHTML = '・おひとり様1回まで利用可能です。<br>・クーポンの併用はできません。<br>・対象外：初回の定期オトク便、一部セール品<br>・お客様都合で注文キャンセルされた場合は、クーポンの再発行はできません。';
            pElement.style.cssText = "text-align: left; font-size:12px; line-height: 1.83; color: #1a1a1a;"
            if (buttonContainer.firstChild) {
                buttonContainer.insertBefore(pElement, buttonContainer.firstChild);
            } else {
                buttonContainer.appendChild(pElement);
            }

            // モーダルオープン用の「交換する」ボタンを追加
            const newDiv = document.createElement('div');
            newDiv.className = 'thanksmile-modal-button-container';

            const newButton = document.createElement('button');
            newButton.innerText = '交換する';
            newButton.className = 'lion-action-button thanksmile-modal-open-button';

            newDiv.appendChild(newButton);
            
            // buttonContainerの中に新しいdivを挿入
            buttonContainer.appendChild(newDiv);
        }
        // modal__point__amount クラスの要素に redeemAmount を設定
        const pointAmountElement = document.querySelector('.modal__point__amount');
        if (pointAmountElement) {
            pointAmountElement.innerText = redeemAmount.replace("¥", "");
        }

        // モーダルの動きを制御する関数呼び出し
        if(document.querySelector('button.lion-action-button.thanksmile-modal-open-button')) {
            modalContent();
        }

        const newRewardButton = document.querySelector('.lion-action-button.lion-redeem-reward-modal__button.lion-redeem-reward-modal__button--confirm')
        const howToUseCoupon = document.querySelector('.how-to-use-coupon-wrapper');
        const clone = howToUseCoupon.cloneNode(true);

        if(originalButton) {
            newRewardButton.addEventListener('click', function() {
                // モーダルを閉じる
                const modal = document.querySelector('#confirmation-modal-content');
                const modalBg = document.querySelector('#confirmation-modal-bg');
                modal.classList.remove('show');
                modalBg.classList.remove('show');
                originalButton.click();

                setTimeout(()=> {
                    const couponModal = document.querySelector('.lion-redeem-reward-modal .lion-modal__content');
                    couponModal.parentNode.insertBefore(clone, couponModal.nextSibling);
                    clone.style.display = 'block';
                },1000)
            })
        }
    }
    
    const makeChangeHtmlRewardModalComment = function () {
        let pacLink = sessionStorage.getItem('pacLink');
        if (pacLink === null || pacLink === 'null') {
            pacLink = '/collections/all';
        } else if (!(pacLink.includes('?categoryId')) && pacLink.includes('gid') && pacLink === '/collections/all') {
            pacLink = pacLink + '?categoryId=coupon';
        }

        const title = document.querySelector(".lion-modal__title").innerText;
        const redeemAmount = extractAmountRedeemFromTitle(title);
        const imgUrl = fromTitleToCouponImage(title, 'claimed')
        const amountClass = imgUrl.includes("_back.png") === false ? 'is-hidden' : ''

        let imageEl = document.querySelector('.lion-history-info-modal-content__comment-min-spend');
        // imageElがなかったらdivを作成して追加
        if (!imageEl) {
            const newDiv = document.createElement('div');
            newDiv.className = 'lion-history-info-modal-content__comment-min-spend';
            const modalContent = document.querySelector('.lion-history-info-modal-content__comment');
    
            // 最初の子要素として追加
        if (modalContent) {
            modalContent.insertBefore(newDiv, modalContent.firstChild);
        }
            imageEl = newDiv;
        }

    if (imageEl) { // imageEl が存在するか確認してからinnerHTMLを設定
        imageEl.innerHTML += `<div class="bg-zenb-point"><img class="bg-zenb-point__img" src="${imgUrl}"/><div class="zenb-point-amount ${amountClass}">${redeemAmount}<span>OFF</span></div></div>`;
        if(imgUrl.includes("_default.png")) {
            const amountEl = imageEl.querySelector('.zenb-point-amount');
            if (amountEl) amountEl.style.display = 'none';
            // imageElの中にspanを追加
            const spanEl = document.createElement('span');
            spanEl.className= 'coupon__name';
            spanEl.innerHTML = 'クーポン<br>交換済み';
            spanEl.style.cssText = "font-size: 26px; color: #fff; position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); width: 63%; display: block; background: #308053; padding: 6px 32px; font-weight: bold; text-align: center;"
            imageEl.appendChild(spanEl);
        }
        const positions = ['top-left', 'top-left2', 'top-right', 'bottom-left', 'bottom-right','bottom-right2','bottom-right3'];
        if(imgUrl.includes("coupon2")) {
            positions.forEach(position => {
                const imgWrapper = document.createElement('div');
                imgWrapper.classList.add('corner-img-wrapper', position);
                imgWrapper.style.backgroundImage = `url('//zenb.jp/cdn/shop/t/212/assets/glitter.png?v=35453654064398462741754355982')`;
                imageEl.appendChild(imgWrapper);
            });
        }
    }

    const modalCloseButton = document.querySelector('div.lion-modal--zenb .lion-modal__close-button');
    if (modalCloseButton) modalCloseButton.innerHTML = '< 戻る';

        const contentEle = document.querySelector('div.lion-modal--zenb .lion-history-info-modal-content');
    
        const htmlText = `<div class="lion-history-info-modal-content__explain-point">
                <span>${(pacLink !== '/collections/all') ? '「定期オトク便に使う」' : '「お買い物を楽しむ」'}ボタンよりお好きな商品をお選びください。注文手続きの画面で、クーポンコードを入力いただくと、割引価格が適用されます。</span>
            </div>`;

        if (contentEle) {
        contentEle.innerHTML += htmlText;
    
        // 移動させる要素と、挿入先の要素を取得
        const explainPointElement = contentEle.querySelector('.lion-history-info-modal-content__explain-point');
        const rewardCodeElement = contentEle.querySelector('.lion-reward-code');
            if (explainPointElement && rewardCodeElement && rewardCodeElement.parentNode) {
            // 移動させる要素を挿入先の要素の直前に挿入
            rewardCodeElement.parentNode.insertBefore(explainPointElement, rewardCodeElement);
        }

        const ctaLabel  = pacLink !== '/collections/all'
            ? '定期オトク便に使う'
            : 'お買い物を楽しむ';

        const buttonCTA = `
            <div class="lion-redeem-reward-modal__button-container">
                <a href="${pacLink}" class="lion-action-button lion-action-button--fixed-width lion-redeem-reward-modal__button lion-redeem-reward-modal__button--confirm btn-zenb-coupon-apply">
                    <span>${ctaLabel}</span>
                </a>
            </div>`
        contentEle.innerHTML += buttonCTA
        }
        
        const modalTitle = document.querySelector(".lion-modal__title");
        if (modalTitle) modalTitle.innerHTML = `<span>クーポンを獲得しました！</span>`;

        // Insert collection
        makeInsertCollectionProducts()
    }
    

    const makeChangeHtmlAfterRedeemModalSummary = function () {
        let pacLink = sessionStorage.getItem('pacLink');
        if (pacLink === null || pacLink === 'null') {
            pacLink = '/collections/all';
        } else if (!(pacLink.includes('?categoryId')) && pacLink.includes('gid') && pacLink === '/collections/all') {
            pacLink = pacLink + '?categoryId=coupon';
        }

        const text = `${(pacLink !== '/collections/all') ? '「定期オトク便に使う」' : '「お買い物を楽しむ」'}ボタンよりお好きな商品をお選びください。注文手続きの画面で、クーポンコードを入力いただくと、割引価格が適用されます。`;

        const title = document.querySelector(".lion-modal__title").innerText;
        const redeemAmount = extractAmountRedeemFromTitle(title);
        const imgUrl = fromTitleToCouponImage(title, 'claimed');
        const amountClass = imgUrl.includes("_back.png") === false ? 'is-hidden' : '';
        const rotateClass = imgUrl.includes("_back.png") === false ? 'rotate-5deg' : '';

        console.log("image URL " + imgUrl);
        let cornerImagesHtml = '';
        const positions = ['top-left', 'top-left2', 'top-right', 'bottom-left', 'bottom-right','bottom-right2','bottom-right3'];

        if(imgUrl.includes("coupon2" || imgUrl.includes("shipping"))) {
            positions.forEach(position => {
                cornerImagesHtml += `<div class="corner-img-wrapper ${position}" style="background-image: url('//zenb.jp/cdn/shop/t/212/assets/glitter.png?v=35453654064398462741754355982');"></div>`;
            });
        }
        
        const html = `<div class="lion-redeem-reward-modal__summary">
            <div class="lion-redeem-reward-modal__summary-bg">
                <div class="bg-zenb-point">
                    <img class="bg-zenb-point__img ${rotateClass}" src="${imgUrl}"/>
                    <div class="zenb-point-amount ${amountClass}">${redeemAmount}<span>OFF</span></div>
                </div>
                ${cornerImagesHtml}
            </div>
            <p>${text}</p>
        </div>`;
        document.querySelector('.lion-redeem-reward-modal__summary-zenb').innerHTML = html;
        
        const codeContainer = document.querySelector('.lion-modal--zenb .lion-redeem-reward-modal__code-container');

        if (codeContainer && pacLink) {
            // 新しい要素を作成
            const ctaLabel = pacLink !== '/collections/all'
                ? '定期オトク便に使う'
                : 'お買い物を楽しむ';
            const newElement = document.createElement('div');
            newElement.className = 'lion-redeem-reward-modal__button-container';
            newElement.innerHTML = `
                <a href="${pacLink}" class="lion-action-button lion-action-button--fixed-width lion-redeem-reward-modal__button lion-redeem-reward-modal__button--confirm lion-redeem-reward-modal__button--margin-right btn-zenb-coupon-apply">
                    <span>${ctaLabel}</span>
                </a>
            `;

            // 新しい要素を .lion-redeem-reward-modal__code-container の次に挿入
            codeContainer.parentNode.insertBefore(newElement, codeContainer.nextSibling);
        }
        document.querySelector(".lion-modal__title").innerHTML = `<span>クーポンを獲得しました！</span>`;

        // consumption-text クラスのタグを display: none にする
        const consumptionTextElement = document.querySelector('.consumption-text');
        if (consumptionTextElement) {
            consumptionTextElement.style.display = 'none';
        }

        // Insert collection
        makeInsertCollectionProducts();
        makeChangeHtmlRewardClaimedList();
    };

    const makeInsertCollectionProducts = function () {
        const modalZenb = document.querySelector('div.lion-modal--zenb')
        if (modalZenb) {
            const collection = modalZenb.querySelector('.collection')
            // if (!collection) {
            //     modalZenb.querySelector('div.lion-modal__content').innerHTML += document.getElementById('collection-zenb-point').innerHTML
            // }

            modalZenb.querySelectorAll('.btn__zenb-quickbuy').forEach((btn) => {
                if (!btn.classList.contains('btn-zenb-coupon-apply')) {
                    btn.classList.add('btn-zenb-coupon-apply')
                }
            })

            // Add term of use
            const termHtml = `
            <div class="zenb-term-of-use-point">
                <h3 class="zenb-term-of-use-point__title">【クーポン利用条件】</h3>
                <ul class="zenb-term-of-use-point__content">
                    <li>・おひとり様1回まで利用可能です。</li>
                    <li>・クーポンの併用はできません。</li>
                    <li>・対象外：初回の定期オトク便、一部セール品</li>
                    <li>・お客様都合で注文キャンセルされた場合は、クーポンの再発行はできません。</li>
                </ul>
            </div>`

            modalZenb.querySelector('div.lion-modal__content').innerHTML += termHtml
        }
        removeLightScreenOverride()
        // Listen apply coupon button
        const zenbApplyCouponButtons = modalZenb.querySelectorAll('.btn-zenb-coupon-apply')
        if (zenbApplyCouponButtons) {
            zenbApplyCouponButtons.forEach((b) => {
                watchZenbApplyCouponButton(b)
            })
        }

    }

    const makeChangeHtmlHistoryList = function () {
        hideHistoryBefore()
        const zenbPointPagination = new ZenbPointPaginationComponent();
        zenbPointPagination.init();
    }

    const removeLightScreenOverride = function () {
        const lightScreenEle = document.querySelector('div.lion-screen.lion-screen--light')
        if (lightScreenEle) {
            lightScreenEle.remove()
        }
    }

    const extractAmountRedeemFromTitle = function (title, onlyNumber = false) {
        // ¥100割引クーポンに交換 or 100円OFFクーポン
        let extracted = ""
        if (title.includes("円OFF")) {
            extracted = title.substring(0, title.indexOf("円OFF") + 1);
        } else if (title.includes("割引")) {
            extracted = title.substring(0, title.indexOf("割引"));
        } else if( title.includes("送料無料")) {
            extracted = "送料無料";
        }
        if (onlyNumber) {
            extracted = extracted.replace("¥", "").replace("円", "").replace(",", "");
        }
        return extracted
    }

    const fromTitleToCouponImage = function (title, type = 'claimed') {

        const defaultImgClaimed = "//zenb.jp/cdn/shop/t/212/assets/coupon_default.png?v=27869217525680045011754355973"
        const defaultImgReward = "//zenb.jp/cdn/shop/t/212/assets/coupon_default.png?v=27869217525680045011754355973"

        const imgs = {
            "100_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_100.png?v=169102292476836454451754355968",
            "100_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_100.png?v=169102292476836454451754355963",
            "200_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_200.png?v=168151831674440261521754355969",
            "200_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_200.png?v=168151831674440261521754355964",
            "300_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_300.png?v=60678104810395983661754355970",
            "300_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_300.png?v=60678104810395983661754355965",
            "400_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_400.png?v=51508862563593314391754355970",
            "400_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_400.png?v=51508862563593314391754355965",
            "500_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_500.png?v=22833405977087413941754355971",
            "500_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_500.png?v=22833405977087413941754355966",
            "600_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_600.png?v=7124691917207252891754355971",
            "600_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_600.png?v=69652557889811188441754355966",
            "700_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_700.png?v=30542353132422445061754355971",
            "700_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_700.png?v=76897682434914275181754355966",
            "800_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_800.png?v=15447633233214608651754355972",
            "800_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_800.png?v=15447633233214608651754355967",
            "900_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_900.png?v=38133705112757806111754355972",
            "900_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_900.png?v=100629353404802647461754355967",
            "1000_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_1000.png?v=170752626227111753281754355968",
            "1000_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_1000.png?v=170752626227111753281754355963",
            "2000_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_2000.png?v=100099993412999525851754355969",
            "2000_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon2_2000.png?v=100099993412999525851754355964",
            "default_reward": defaultImgReward,
            "default_claimed": defaultImgClaimed,
            "default_shipping_reward": "//zenb.jp/cdn/shop/t/212/assets/coupon_default_shipping.png?v=72591230134275690821754355974",
            "default_shipping_claimed": "//zenb.jp/cdn/shop/t/212/assets/coupon_default_shipping.png?v=72591230134275690821754355974",
        }

        const number = extractAmountRedeemFromTitle(title, true)

        if(number.includes("送料無料")) {
            return imgs[`default_shipping_${type}`]
        }else if (number) {
            return imgs[`${number}_${type}`] || imgs[`default_${type}`]
        }

        return imgs[`default_${type}`]
    }

    const hideHistoryBefore = function (inputDate) {
        const date = inputDate || (new Date('2023-03-14'))
        const dateStr = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`

        const historyItems = document.querySelectorAll('.loyaltylion-zenb-history__table .lion-history-table .lion-history-table__row')
        historyItems.forEach((ele) => {
            const historyDateEle = ele.querySelector('.lion-history-table__row-date')

            if (historyDateEle) {
                const historyDate = new Date(historyDateEle.innerText)

                if (isValidDate(historyDate) && isValidDate(date) && date > historyDate) {
                    ele.remove()
                }
            }
        })
    }

    const watchZenbApplyCouponButton = function (button) {
        let pacLink = sessionStorage.getItem('pacLink');
        if(pacLink === null || pacLink === 'null'){
            pacLink = '/collections/all'
        }else if (typeof pacLink === 'string' && pacLink.includes('SubscriptionContract') && !pacLink.includes('?categoryId=')) {
            pacLink += '?categoryId=coupon';
        }

        button.setAttribute('data-redirect', pacLink)
        button.setAttribute('href', '#')

        button.addEventListener('click', (e) => {
            e.preventDefault()
            const couponEle = document.querySelector('.lion-modal--zenb .lion-reward-code__code')
            if (couponEle) {
                const couponCode = couponEle.innerText
                let redirectUrl = e.target.getAttribute("data-redirect")
                zenbPointStorage.set('coupon', couponCode)
                closeModal()

                if (!redirectUrl) {
                    const target = e.target.closest('.lion-action-button')
                    redirectUrl = target.getAttribute("data-redirect")
                }

                if (redirectUrl) window.location.href = redirectUrl
            }
            })        
    }

    // コピーボタン
    document.addEventListener('click', function(event) {
        // クリックされた要素が lion-reward-code__clipboard-button クラスのボタンか確認
        if (event.target.classList.contains('lion-reward-code__clipboard-button')) {
            // ボタンの直前の要素を取得
            const codeElement = event.target.previousElementSibling;
    
            // 直前の要素が lion-reward-code__code クラスを持っているか確認
            if (codeElement && codeElement.classList.contains('lion-reward-code__code')) {
                // テキストを取得してクリップボードにコピー
                const codeText = codeElement.innerText;
                copyToClipboard(codeText);
                alert('クーポンコードがコピーされました: ' + codeText);
            }
        }
    });
    
    // テキストをクリップボードにコピーする関数
    function copyToClipboard(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }
    

    const isValidDate = function (d) {
        return d instanceof Date && !isNaN(d);
    }

    const initComponent = function () {
        setupEvent()
    }

    const zenbPointStorage = window.zenbPointStorage || new ZenbStorageComponent()

    return {
        init: initComponent
    }
}

function ZenbPointPaginationComponent() {

    const renderContainer = document.querySelector('.loyaltylion-zenb-history__pagination-wrapper');
    const paginationNumbers = document.getElementById("zenb-pagination-numbers");
    const paginatedList = document.querySelector(".loyaltylion-zenb-history__table #loyaltylion .lion-history-table tbody");
    const listItems = paginatedList.querySelectorAll(".lion-history-table__row");
    const nextButton = document.getElementById("zenb-next-button");
    const prevButton = document.getElementById("zenb-prev-button");

    const paginationLimit = 5;
    const pageCount = Math.ceil(listItems.length / paginationLimit);
    let currentPage = 1;

    const disableButton = (button) => {
        button.classList.add("disabled");
        button.setAttribute("disabled", true);
    };

    const enableButton = (button) => {
        button.classList.remove("disabled");
        button.removeAttribute("disabled");
    };

    const handlePageButtonsStatus = () => {
        if (currentPage === 1) {
            disableButton(prevButton);
        } else {
            enableButton(prevButton);
        }

        if (pageCount === currentPage) {
            disableButton(nextButton);
        } else {
            enableButton(nextButton);
        }
    };

    const handleActivePageNumber = () => {
        document.querySelectorAll(".zenb-pagination-number").forEach((button) => {
            button.classList.remove("active");
            const pageIndex = Number(button.getAttribute("data-page-index"));
            if (pageIndex == currentPage) {
                button.classList.add("active");
            }
        });
    };

    const handleShortPaginationDisplay = () => {
        const currentPageEle = document.querySelector(".zenb-pagination-number.active")
        const pageIndex = Number(currentPageEle.getAttribute("data-page-index"))

        const firstPage = 1
        const lastPage = pageCount


        if (pageCount <= 4) {
            // ignore process buttons ...
        } else if (pageCount > 4) {
            paginationNumbers.innerHTML = ""
            const nextPage = pageIndex + 1;
            const prevPage = pageIndex - 1;

            appendPageNumber(firstPage)

            if (prevPage === 2) {
                appendPageNumber(prevPage)
            } else if (pageIndex - firstPage > 2) {
                appendPageNumber('...')
                appendPageNumber(prevPage)
            }

            if (pageIndex !== firstPage) {
                appendPageNumber(pageIndex)
            }


            if (lastPage - pageIndex === 2) {
                appendPageNumber(nextPage)
            } else if (lastPage - pageIndex > 1) {
                appendPageNumber(nextPage)
                appendPageNumber('...')
            }

            if (pageIndex !== lastPage) {
                appendPageNumber(lastPage)
            }
        }
        document.querySelectorAll(".zenb-pagination-number").forEach((button) => {
            const clickPage = button.getAttribute("data-page-index")
            if (clickPage === '...') {
                //ignore
            } else {
                button.addEventListener("click", () => {
                    setCurrentPage(Number(clickPage));
                });
                if (clickPage == pageIndex) {
                    button.classList.add("active");
                }
            }
        });
    };

    const appendPageNumber = (index) => {
        const pageNumber = document.createElement("button");
        pageNumber.className = "zenb-pagination-number";
        pageNumber.innerHTML = index;
        pageNumber.setAttribute("data-page-index", index);
        pageNumber.setAttribute("aria-label", "Page " + index);

        paginationNumbers.appendChild(pageNumber);
    };

    const getPaginationNumbers = () => {
        for (let i = 1; i <= pageCount; i++) {
            appendPageNumber(i);
        }
    };

    const setCurrentPage = (pageNum) => {
        currentPage = pageNum;

        handleActivePageNumber();
        handlePageButtonsStatus();
        handleShortPaginationDisplay();

        const prevRange = (pageNum - 1) * paginationLimit;
        const currRange = pageNum * paginationLimit;

        listItems.forEach((item, index) => {
            item.classList.add("is-hidden");
            if (index >= prevRange && index < currRange) {
                item.classList.remove("is-hidden");
            }
        });
    };

    const initComponent = function () {

        getPaginationNumbers();
        setCurrentPage(1);

        prevButton.addEventListener("click", () => {
            setCurrentPage(currentPage - 1);
        });

        nextButton.addEventListener("click", () => {
            setCurrentPage(currentPage + 1);
        });

        if (pageCount <= 1) {
            renderContainer.classList.add('is-hidden')
        }

    }

    return {
        init: initComponent
    }
}

document.addEventListener('DOMContentLoaded', () => {
    'use strict';

    const zenbPointComponent = new ZenbPointComponent();
    zenbPointComponent.init();


});

const modalContent = () => {
    // 要素を取得
    const openModalButton = document.querySelector('.thanksmile-modal-open-button');
    const modalBg = document.getElementById('confirmation-modal-bg');
    const modalContent = document.getElementById('confirmation-modal-content');
    const closeModalButton = document.getElementById('confirmation-modal-close');

    // 「交換する」ボタンがクリックされたときにモーダルを表示
    if (openModalButton) {
        openModalButton.addEventListener('click', function() {
            modalBg.classList.add('show'); 
            modalContent.classList.add('show');
        });
    }

    // モーダルの閉じるボタンがクリックされたときにモーダルを閉じる
    if (closeModalButton) {
        closeModalButton.addEventListener('click', function() {
            modalBg.classList.remove('show'); 
            modalContent.classList.remove('show'); 
        });
    }

    // モーダルの外側がクリックされたときにモーダルを閉じる
    window.addEventListener('click', function(event) {
        if (event.target == modalBg) {
            modalBg.classList.remove('show'); 
            modalContent.classList.remove('show'); 
        }
    });
}

window.onload = function() {  
    setTimeout(()=> {
        const coupons = document.querySelectorAll('.lion-claimed-reward-item--approved');
        const howToUseCoupon = document.querySelector('.how-to-use-coupon-wrapper');

        if(coupons) {
            coupons.forEach(coupon => {
                coupon.addEventListener('click', function() {
                // howToUseCouponの要素を複製
                    const clone = howToUseCoupon.cloneNode(true);

                    setTimeout(()=> {
                        const couponModal = document.querySelector('.lion-modal--history-info .lion-modal__content');
                        couponModal.parentNode.insertBefore(clone, couponModal.nextSibling);
                        clone.style.display = 'block';
                    },1000)
                });
            });
        }
    },1500)
};

const removeNonExistCoupon = () => {
    document.querySelectorAll('.lion-claimed-reward-item').forEach(function(item) {
        const ariaLabel = item.getAttribute('aria-label');
        if (!ariaLabel || (!ariaLabel.includes('送料無料') && !ariaLabel.includes('¥') && !ariaLabel.includes('￥'))) {
            item.style.display = 'none';
        }
    });
}